import MacAddress from '../../../base/errors/airdome/MacAddress';

const macAddress: MacAddress = {
  unableToAdd: 'Geräte-MAC-Adresse kann nicht hinzugefügt werden',
  unableToRemove: 'Geräte-MAC-Adresse kann nicht entfernt werden'
};

export default macAddress;
